import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { values } from 'ramda'
import { LOCALE_MAP } from '../constants'

Vue.use(VueI18n)

const dateTimeFormats = {}
values(LOCALE_MAP).forEach((locale) => {
  dateTimeFormats[locale] = {
    weekday: {
      weekday: 'long',
    },
  }
})

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en-GB',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-GB',
  messages: {},
  dateTimeFormats,
  silentFallbackWarn: true,
})
